import React, { memo } from "react";
import ContentLoader from "react-content-loader";
import styled from "styled-components";
import rand from "astrid-helpers/src/rand";
import { useSize } from "./state/size";
const StyledLoader = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "StyledLoader",
  componentId: "sc-1074l3f-0"
})(["position:absolute;top:5px;left:50%;padding:6%;background-color:#ffffff;transform:translateX(-50%);"]));
const Loader = /*#__PURE__*/memo(({
  ratio
}) => {
  const height = useSize();
  const width = Math.round(height / ratio);
  return (
    /*#__PURE__*/
    // 1:1.414
    React.createElement(StyledLoader, {
      style: {
        height,
        width
      }
    }, /*#__PURE__*/React.createElement(ContentLoader, {
      viewBox: `0 0 500 707`
    }, /*#__PURE__*/React.createElement("rect", {
      x: "0",
      y: "0",
      width: rand(350, 500),
      height: "10"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "0",
      y: "20",
      width: rand(350, 500),
      height: "10"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "0",
      y: "40",
      width: rand(350, 500),
      height: "10"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "0",
      y: "60",
      width: rand(350, 500),
      height: "10"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "0",
      y: "80",
      width: rand(350, 500),
      height: "10"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "0",
      y: "100",
      width: rand(350, 500),
      height: "10"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "0",
      y: "120",
      width: rand(350, 500),
      height: "10"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "0",
      y: "140",
      width: rand(350, 500),
      height: "10"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "0",
      y: "180",
      width: rand(350, 500),
      height: "10"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "0",
      y: "200",
      width: rand(350, 500),
      height: "10"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "0",
      y: "220",
      width: rand(350, 500),
      height: "10"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "0",
      y: "240",
      width: rand(350, 500),
      height: "10"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "0",
      y: "260",
      width: rand(350, 500),
      height: "10"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "0",
      y: "280",
      width: rand(350, 500),
      height: "10"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "0",
      y: "320",
      width: rand(350, 500),
      height: "10"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "0",
      y: "340",
      width: rand(350, 500),
      height: "10"
    })))
  );
});
export default Loader;
//# sourceMappingURL=Loader.js.map